import base from "./base.js";
import chiche from "./chiche.js";
import events from "./events.js";
import factory from "./factory.js";
import jobs from "./jobs.js";
import spot from "./spot.js";
import tv from "./tv.js";
export default { base, chiche, events, factory, jobs, spot, tv };